import { render, staticRenderFns } from "./pwa_bg.vue?vue&type=template&id=658a4d95&scoped=true&"
import script from "./pwa_bg.vue?vue&type=script&lang=js&"
export * from "./pwa_bg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "658a4d95",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('658a4d95')) {
      api.createRecord('658a4d95', component.options)
    } else {
      api.reload('658a4d95', component.options)
    }
    module.hot.accept("./pwa_bg.vue?vue&type=template&id=658a4d95&scoped=true&", function () {
      api.rerender('658a4d95', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/aggregators/pwa/settings/tabs/images/pwa_bg.vue"
export default component.exports